<template>
  <form ref='fowardRecordMessageForm' @submit.prevent='submitForwardMessage' class="send-reply">
    <div class="form-group">
      <label for="record_message_sent_contacts">{{ $t('record_message.forward_to_label')}}:</label>
      <multi-select v-model="selectedAddressBook" :options='messageAddressBook' />
    </div>
    <div class="form-group"v-show="showBody">
      <label for="record_message_body">{{ $t('record_message.message_label')}}:</label>
      <input type="hidden" id='record_message_body' name="record_message[body]" v-model="recordMessageBody" />
      <trix-editor input="record_message_body" class="trix-body tinymce form-control" v-html="initialMessage"></trix-editor>
    </div>
    <div class="form-group float-right">
      <button class="btn btn-outline-danger m-r-10" :disabled="isProcessing" @click.prevent="close()">
        {{ $t('record_show.cancel') }}
      </button>
      <button type="submit" class="btn btn-outline-primary submit-note" :disabled="recordMessageBody == '' || selectedAddressBook.length === 0 || isProcessing">
        {{$t('record_message.forward')}}
        <i class="fas fa-circle-notch fa-spin" v-show="isProcessing"></i>
      </button>
    </div>
  </form>
</template>

<script>
 import _multi_select from "../../components/shared/_multi_select"
 import 'trix'
 import 'trix/dist/trix.css'

 export default {
     components: {
       'multi-select': _multi_select
     },
     data() {
         return {
             selectedAddressBook: [],
             recordMessageBody: '',
             isProcessing: false
         }
     },
     props: {
         message: {
             type: Object,
             required: true
         },
         addressBook: {
             type: Array,
             required: true
         }
     },
     mounted(){
       document.addEventListener("trix-change", this.setTextToTrix)
     },
     beforeDestroy() {
       document.removeEventListener("trix-change", this.setTextToTrix)
     },
     computed: {
       initialMessage(){
         return this.$props.message.body+'<br />'
       },
       selectedFromMessage(){
         return this.addressBookCollection.selected || []
       },
       messageAddressBook(){
         return this.addressBookCollection.collection || []
       },
       showBody(){
         if(this.$props.message.body !== undefined){
           this.recordMessageBody = this.$props.message.body+'<br />'
           return true
         }
         return false
       },
       addressBookCollection(){
         let list =  this.$props.addressBook.map( (item) => { return { id: item.id, name: item.name } }, [])
         let message = this.$props.message
         let sent_messages = message.sent_messages || []
         let replies = message.replies || []
         let from_user = message.from_user || null
         let currentOrg = this.currentOrg
         let removed = []
         let collection = []

         sent_messages.map( (item) => {
           let to_user = item.to_user || null
           let to_contact = item.to_contact || null

           if(to_user){
             if(this.listIncludes(list, to_user.id+'-User'))
               removed.push(to_user.id+'-User')
           }
           if(to_contact){
             if(this.listIncludes(list, to_contact.id+'-Contact'))
                 removed.push(to_contact.id+'-Contact')
           }
         })

         replies.map( (item) => {
           let sent_messages = item.sent_messages || null
           sent_messages.map( (sent_message) => {
             let to_user = sent_message.to_user || null
             let to_contact = sent_message.to_contact || null

             if(to_user){
               if(this.listIncludes(list, to_user.id+'-User'))
                 removed.push(to_user.id+'-User')
             }
             if(to_contact){
               if(this.listIncludes(list, to_contact.id+'-Contact'))
                   removed.push(to_contact.id+'-Contact')
             }
           })
         })

         if(from_user){
           if(this.listIncludes(list, from_user.id+'-User'))
             removed.push(from_user.id+'-User')
         }

         collection = list.filter( (item) => { return !removed.includes(item.id) })

         return { collection: collection, selected: [], removed: removed }
       }
     },
     methods: {
       setTextToTrix: function() {
         this.recordMessageBody = document.getElementById("record_message_body").value
       },
       close() {
         this.$emit('success')
       },
       formatName(name, email){
         if(email)
           return `${name} <${email}>`
         else
           return name
       },
       listIncludes(list, id){
         return list.map( (item) => { return item.id }).includes(id)
       },
       submitForwardMessage(e){
           let params = new FormData(e.target)
           let message = this.$props.message || {}

           this.selectedAddressBook.forEach(function (item) {
               let index = item.id.split('-')
               let id = index[0]
               let resource = index[1]

               if(resource === 'Contact')
                   params.append('record_message_sent[contact_ids][]', id)
               if(resource === 'User')
                   params.append('record_message_sent[user_ids][]', id)
           })

           this.isProcessing = true
           this.store.createForwardMessage(message.record_id, message.id, params).then(({}) => {
               this.$toastr.success(this.$t('record_message.message_successfully_sent'))
               this.sendMetricComponent('send_forward_message')

               e.target.reset()
               this.close()
           }).finally(() => {
             this.isProcessing = false
           })
       },
       sendMetricComponent(name){
         let metric_name = 'file_communication_record_show_'+name

         if(this.$props.resourceType == 'SharedRecord')
           metric_name = 'shared_record_communication_'+name
         if(this.$props.resourceType == 'RecordMessageShow')
           metric_name = 'file_communication_show_'+name

         this.store.sendMetrics({name: metric_name, params: this.$route.params, path: this.$route.fullPath})
      }
     }
 }
</script>
<style lang="sass" scoped>
  .custom-select
    display: block
  .trix-body
    height: 350px
    overflow-y: auto
    margin-bottom: 1rem
</style>
